export enum DocumentEntityTypes {
  Application = 1,
  Loan = 2,
}
